/* eslint-disable react-hooks/exhaustive-deps */
import SpinnerComponent from "components/common/spinnerComponent";
import { IUserContext } from "models";
import { useEffect } from "react";
import { redirect, useNavigate } from "react-router-dom";
import RoutingConstants from "utils/routingConstants";
import { StorageService } from "utils/sessionService";
import * as AuthService from "services/authService";

const SigninCallbackComponent = (props) => {
  const navigate = useNavigate();

  const { azureAuth } = props;

  useEffect(() => {
    azureAuth
      .handleRedirectPromise()
      .then((authResult) => {
        var loginRequest = {
          scopes: ["user.read", "mail.send"], // optional Array<string>
        };
        // console.log("Auth Result - ", authResult);
        // Check if user signed in
        if (authResult === null) {
          // redirect anonymous user to login page
          azureAuth.loginRedirect(loginRequest);
        } else {
          getUserDataByEmail(authResult, (result) => {
            // console.log("User Email Context - ", result);

            if (result.role_Name !== "Super Admin") {
              if (result && result.store_ID !== 0) {
                getUserFileType(result.store_ID, "StoreGroup");
              } else {
                if (true) {
                  getUserFileType(result.nID);
                }
              }
            }
            handleResultToken(authResult, result, (context) => {
              // console.log("User Context Object - ", context);
              StorageService.setSLSItem("UserContext", context, false);
              props.setUserContext(context);
              navigate(RoutingConstants.default, { replace: true });
            });
          });
        }
      })
      .catch((err) => {
        // TODO: Handle errors
        console.log(err);
      });
  }, []);

  const getUserDataByEmail = (authResult: any, callback?: any | void) => {
    const { account } = authResult;
    // console.log(account);
    const email = account["username"] ?? "";
    if (email !== "")
      AuthService.getUserDataByEmail(email)
        .then((result) => {
          const { data } = result;
          getPagePrivilegesByRoleId(data.role_ID, (privilegeResult) => {
            data.privileges = privilegeResult;
            callback && callback(data);
          });
        })
        .catch((err) => {
          if (err.response.status === 404) {
            navigate(RoutingConstants.userDoesNotExist, { replace: true });
          }
          throw err;
        });
  };

  const handleResultToken = (
    authResult: any,
    result: any,
    callback?: any | void
  ) => {
    console.log("Handle Auth Token - ", authResult);
    console.log("Auth API Object - ", result);
    const { accessToken, account } = authResult;
    const userContext: IUserContext = {
      token: accessToken,
      userId: account["localAccountId"] ?? "",
      userName: account["name"] ?? "",
      store: result["store_ID"] ?? "",
      email: account["username"] ?? "",
      roleId: result["role_ID"],
      roleName: result["role_Name"],
      isAdmin: result["isAdmin"],
      isUser: result["isUser"],
      groupType: result["nID_Type"] ?? 0,
      groupTypeId: result["nID"] ?? 0,
      groupTypeName: result["nName"] ?? "",
      privileges: result["privileges"] ?? [],
    };
    callback && callback(userContext);
  };

  const getPagePrivilegesByRoleId = (roleId: string, callback?: void | any) => {
    if (roleId)
      AuthService.getPagePrivilegesByRoleId(roleId)
        .then((result) => {
          const { data } = result;
          callback && callback(data);
        })
        .catch((err) => {
          throw err;
        });
  };

  const getUserFileType = (StoreOrIdGroup: number, UserType = null) => {
    AuthService.getUserFileType(StoreOrIdGroup, UserType)
      .then((result) => {
        const { records } = result;
        StorageService.setSLSItem("UserType", records, false);
        props.setUserFileType(records);
      })
      .catch((err) => {
        throw err;
      });
  };

  return (
    <>
      <SpinnerComponent message={`Signing In`} />
    </>
  );
};

export default SigninCallbackComponent;
